import { defineComponent as _defineComponent } from 'vue'
import SimpleForm from "./SimpleForm.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'NewValidatedFormDemo',
  setup(__props) {


return { __sfc: true,SimpleForm }
}

})